import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    maxWidth: 600,
    paddingLeft: 0,
    backgroundColor: theme.palette.background.paper,
  },
  list: {
    marginBottom: 16,
  },
}));
